import '../css/app.scss';
import 'lazysizes';
import 'lazysizes/plugins/unload/ls.unload';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Keyboard, EffectFade, Thumbs, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';
import 'magnific-popup';
import Splitting from 'splitting';

// Import jQuery BEFORE using it or making it global
import jQuery from 'jquery';

// Make jQuery global FIRST, before other modules
window.jQuery = window.$ = jQuery;

// Configure Swiper with modules and make it global
Swiper.use([Navigation, Pagination, Autoplay, Keyboard, EffectFade, Thumbs, Mousewheel]);
window.Swiper = Swiper;

// Also make modules available separately for reference
window.SwiperModules = {
  Navigation,
  Pagination,
  Autoplay,
  Keyboard,
  EffectFade,
  Thumbs,
  Mousewheel
};

import initMenuToggle from './components/menu-toggle.js';
// import "./gravityforms/collapsible-sections.js";
// import "./gravityforms/debugging.js";
// import "./components/LowPolyGenerator.js";

import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

// Import local dependencies
import Router from './util/Router';
import camelCase from './util/camelCase';

// Import routes
import common from './routes/common';
import home from './routes/home';
// Import other routes as needed

// Initialize the router
const routes = new Router({
  common,
  home,
});

document.addEventListener('DOMContentLoaded', () => {
  // Initialize components first
  initMenuToggle();

  // Then load route events
  routes.loadEvents();
});

// HMR support
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    console.log('Module updated', newModule);
  });
}
